export default __webpack_public_path__ + "static/media/banner-site-agencias-mobile-2.1acee86a.png";